import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const GroupsApi = createApi({
  reducerPath: "Groups",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    getGroups: builder.query({
      query: (val) => `groups`,
    }),
    getAllGroups: builder.query({
      query: (val) => `groups?all=true`,
    }),
    getSpecificGroup: builder.query({ query: (val) => `groups/${val}` }),
    getUserGroup: builder.query({ query: (val) => `groups?userId=${val}` }),
    addGroups: builder.mutation({
      query: (val) => ({
        url: `/groups`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: val,
      }),
    }),
    editGroups: builder.mutation({
      query: ({ val, id }) => ({
        url: `/groups/${id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: val,
      }),
    }),
    deleteGroups: builder.mutation({
      query: (id) => ({
        url: `/groups/${id}`,
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }),
    }),
  }),
});

export const {
	useGetGroupsQuery,
	useGetAllGroupsQuery,
	useGetUserGroupQuery,
	useLazyGetUserGroupQuery,
	useGetSpecificGroupQuery,
	useLazyGetSpecificGroupQuery,
	useAddGroupsMutation,
	useEditGroupsMutation,
	useDeleteGroupsMutation,
} = GroupsApi;
